<template>
  <div class="pt-page pt-page-3 pt-page-current show-overflow" >
    <router-link class="top-nav" to="/"><i class="fa fa-arrow-up"></i></router-link>
    <router-link class="logo" to="/">OM</router-link>
    <div class="about-container goup">
      <div class="container">
        <div class="heading-container">
          <h1>About Me</h1>
        </div>
        <div class="row">
          <div class="col-md-10 col-md-offset-1 text-center">
            <img src="../assets/images/about-image.jpg" class="about-me-image" alt="">
            <p class="headline">Hello! Thank you for visting my website.</p>
            <p>I've been working on the web full time since 2010, developing, designing, and supporting all manner of websites, web applications, mobile apps, and cloud infrastructure. I enjoy delivering fully optimized, sleek and effective technical solutions, both for myself, and my many clients throughout the years.</p>
            <p>Away from the computer, I'm a big fan of sports of all kinds, including everything from darts to Ski jumping. I also enjoy boxing, flying my drone, and putting Sriracha sauce on almost everything.</p>
            <p>And I'm an avid traveler who likes to take a ton of pictures. Check out some of my photo albums from trips and events sorted by year: <a href="https://2025.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2025</a>, <a href="https://2024.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2024</a>, <a href="https://2023.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2023</a>, <a href="https://2022.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2022</a>, <a href="https://2021.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2021</a>, <a href="https://2019.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2019</a>, <a href="https://2018.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2018</a>, <a href="https://2017.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2017</a>, <a href="https://2016.olliemurphy.com/" target="_blank" rel="noopener noreferrer" >2016</a>.</p>
            <a class="stackoverflow-badge" target="_blank" href="https://stackoverflow.com/users/1547553/ollie-murphy">
              <img src="https://stackoverflow.com/users/flair/1547553.png?theme=dark" width="208" height="58" alt="profile for Ollie Murphy at Stack Overflow, Q&amp;A for professional and enthusiast programmers" title="profile for Ollie Murphy at Stack Overflow, Q&amp;A for professional and enthusiast programmers">
            </a>
            <ul class="about-links">
              <li>
                <router-link to="/resume"><i class="fa fa-id-card" aria-hidden="true"></i></router-link>
                <span>Resumé</span>
              </li>
              <li>
                <a href="http://stackoverflow.com/users/1547553/ollie-murphy" target="_blank"><i class="fa fa-stack-overflow" aria-hidden="true"></i></a>
                <span>StackOverflow</span>
              </li>
              <li>
                <a href="https://github.com/omurphy27" target="_blank"><i class="fa fa-github-alt" aria-hidden="true"></i></a>
                <span>Github</span>
              </li>
              <li>
                <a href="https://www.youtube.com/@olliemurphy7654" target="_blank"><i class="fa fa-youtube" aria-hidden="true"></i></a>
                <span>Youtube</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../assets/css/font-awesome.min.css";
</style>

<style lang="scss">
@import "../assets/scss/about.scss";
</style>

<script>
import JQuery from "jquery";
const $ = JQuery;

export default {
  name: "About",
  mounted: function() {
    const $page = $(".pt-page");
    if ( $page.hasClass('show-overflow') ) {
      $page.find(".goup").addClass("animated fadeInUp");
    }
  }
};
</script>
